var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
// A place for all the openlayers 3 related style definitions to reside in a central place

OCS.Viewer.Functions.define_ol_style_manager = function (in_implements) {
    var implements = [Options, Events];
    if (!in_implements || !in_implements.length) {
        implements.combine([new Class(OCS.Viewer.Interfaces.OlShapeStyle), new Class(OCS.Viewer.Interfaces.OlPointStyle), new Class(OCS.Viewer.Interfaces.OlLineStyle), new Class(OCS.Viewer.Interfaces.OlWindArrowStyle), new Class(OCS.Viewer.Interfaces.OlWindBarbStyle), new Class(OCS.Viewer.Interfaces.OlLightningStyle), new Class(OCS.Viewer.Interfaces.OlAdvisoryStyle)]);
    } else {
        implements.combine(in_implements);
    }
    return new Class({
        Implements: implements,
        manager_name: 'OlStyleManager',
        debug: false,
        style_cache: {},
        options: {
            manager_name: 'ol_style_manager',
            layer_style_ops: {},
            style_type: null,
            style_prop_keys: [
                'fill_color', 'fill_width', 'stroke_color', 'stroke_width', 'text', 'image',
                'font_size', 'font_family', 'radius', 'radius2', 'angle', 'points', 'type', 'scale', 'rotateWithView', 'rotation', 'rotation_offset',
                'anchor', 'anchorXUnits', 'anchorYUnits', 'opacity', 'size', 'offset', 'offsetOrigin', 'src'
            ],
        },
        initialize: function (op) {
            this.setOptions(op);
        },
        build_style_ops: function (ops) {
            var style_ops = {};
            if (!ops) {
                return;
            }
            if (ops.hasOwnProperty('stroke_color') && ops.hasOwnProperty('stroke_width')) {
                style_ops.stroke = new ol.style.Stroke({
                    width: ops.stroke_width,
                    color: ops.stroke_color
                });
            }
            if (ops.hasOwnProperty('fill_color')) {
                var fill_ops = {color: ops.fill_color};
                if (ops.fill_width) {
                    fill_ops.width = ops.fill_width;
                }
                style_ops.fill = new ol.style.Fill(fill_ops);
            }

            // Image related settings
            if (ops.hasOwnProperty('image')) {
                if (typeof ops.image === 'object') {
                    var image_ops = this.build_style_ops(ops.image);
                    if (ops.image.type === 'Circle') {
                        style_ops.image = new ol.style.Circle(image_ops);
                    }
                    if (ops.image.type === 'Icon') {
                        style_ops.image = new ol.style.Icon(image_ops);
                    }
                    if (ops.image.type === 'RegularShape') {
                        style_ops.image = new ol.style.RegularShape(image_ops);
                    }
                }
            }

            if (ops.hasOwnProperty('radius')) {
                style_ops.radius = ops.radius;
            }
            if (ops.hasOwnProperty('radius2')) {
                style_ops.radius2 = ops.radius2;
            }
            if (ops.hasOwnProperty('points')) {
                style_ops.points = ops.points;
            }
            if (ops.hasOwnProperty('angle')) {
                style_ops.angle = ops.angle;
            }
            if (ops.hasOwnProperty('scale')) {
                style_ops.scale = ops.scale;
            }
            if (ops.hasOwnProperty('rotateWithView')) {
                style_ops.rotateWithView = ops.rotateWithView;
            }
            if (ops.hasOwnProperty('rotation')) {
                style_ops.rotation = ops.rotation;
            }
            if (ops.hasOwnProperty('anchor')) {
                style_ops.anchor = ops.anchor;
            }
            if (ops.hasOwnProperty('anchorXUnits')) {
                style_ops.anchorXUnits = ops.anchorXUnits;
            }
            if (ops.hasOwnProperty('anchorYUnits')) {
                style_ops.anchorYUnits = ops.anchorYUnits;
            }
            if (ops.hasOwnProperty('opacity')) {
                style_ops.opacity = ops.opacity;
            }
            if (ops.hasOwnProperty('offsetOrigin')) {
                style_ops.offsetOrigin = ops.offsetOrigin;
            }
            if (ops.hasOwnProperty('offset')) {
                style_ops.offset = ops.offset;
            }
            if (ops.hasOwnProperty('size')) {
                style_ops.size = ops.size;
            }
            if (ops.hasOwnProperty('src')) {
                style_ops.src = ops.src;
            }

            // Text object options
            if (ops.hasOwnProperty('font_size') && ops.hasOwnProperty('font_family')) {
                style_ops.font = ops.font_size + ' ' + ops.font_family;
            }
            if (ops.hasOwnProperty('font')) {
                style_ops.font = ops.font;
            }
            if (ops.hasOwnProperty('text')) {
                if (typeof ops.text === 'object' && ops.text.text) {
                    style_ops.text = new ol.style.Text(this.build_style_ops(ops.text));
                }
                if (typeof ops.text === 'number' || typeof ops.text === 'string') {
                    style_ops.text = ops.text;
                }
                if (!style_ops.text) {
                    style_ops.text = new ol.style.Text({});
                }
            }

            return style_ops;
        },
        set_style_ops: function (in_ops, in_style) {
            var util = OCS.Viewer.Functions.get_utilities();
            var ops = util.clone_object(in_ops, this.options.style_prop_keys);
            // A method to merge incoming style settings with existing defaults
            if (typeof in_style === 'object') {
                if (in_style.font_family && in_style.font_size) {
                    ops.font = in_style.font_size + ' ' + in_style.font_family;
                }
                if (in_style.fill_color) {
                    ops.fill_color = in_style.fontColor;
                }
                if (in_style.fill_width) {
                    ops.fill_width = in_style.fillWidth;
                }
                if (in_style.stroke_color) {
                    ops.stroke_color = in_style.stroke_color;
                }
                if (in_style.stroke_width) {
                    ops.stroke_width = in_style.stroke_width;
                }
                if (in_style.labelOutlineColor) {
                    ops.stroke_color = in_style.labelOutlineColor;
                }
                if (in_style.labelOutlineWidth) {
                    ops.stroke_width = in_style.labelOutlineWidth;
                }
                if (in_style.text) {
                    ops.text = util.combine_objects(ops.text, in_style.text);
                }
                if (in_style.image) {
                    ops.image = util.combine_objects(ops.image, in_style.image, {merge: true});
                }
            }
            return ops;
        },
        get_highlighted_style: function (ops, style) {
            if (!style) {
                style = [];
            }
            style.push(new ol.style.Style({
                fill: new ol.style.Fill({color: 'rgba(255, 50, 50, 0.2)'}),
                stroke: new ol.style.Stroke({color: 'rgba(255, 50, 50, 0.9)', width: 1.25}),
                image: new ol.style.Circle({
                    fill: new ol.style.Fill({
                        color: 'rgba(255, 50, 50, 0.2)'
                    }),
                    stroke: new ol.style.Stroke({
                        width: 2,
                        color: 'rgba(255, 50, 50, 0.9)'
                    }),
                    radius: 5
                })

            }));
            return style;
        },
        get_selected_style: function (ops, style) {
            if (!style) {
                style = [];
            }
            style.push(new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(50, 50, 255, 0.3)'
                }),
                stroke: new ol.style.Stroke({
                    width: 2,
                    color: 'rgba(50, 50, 255, 0.8)'
                })
            }));
            return style;
        },
        get_style_type: function () {
            return this.options.style_type;
        },
        set_style_type: function (type) {
            if (type) {
                this.options.style_type = type;
            }
        },
        get_hover_style: function () {

        },
        get_default_style_ops: function (in_ops) {
            // Base line style that will work for most things
            var ops;
            var style_ops = this.build_style_ops(ops);
            return style_ops;
        },
        get_default_style: function (in_ops) {
            var result = this.get_style_with_ops(this.get_default_style_ops(in_ops));
            return [result];
        },
        get_text_style: function (text, style, text_styles) {
            var text_ops = {
                font: '20px helvetica,arial,sans-serif',
                text: text,
                fill: new ol.style.Fill({
                    color: '#fff',
                    width: 2
                }),
                stroke: new ol.style.Stroke({
                    color: '#444',
                    width: 7
                })
            };
            if(text_styles) {
                if(text_styles.offsetY) {
                    text_ops.offsetY = text_styles.offsetY;
                }
            }


            if (!style) {
                style = [];
            }
            style.push(new ol.style.Style({
                text: new ol.style.Text(text_ops),
                geometry: function (feature) {
                    // expecting a MultiPolygon here
                    var geom = feature.getGeometry();
                    var type = geom.getType();
                    if (type === "MultiPolygon") {
                        var interiorPoints = geom.getInteriorPoints();
                        return interiorPoints.getPoint(1);
                    } else {
                        return geom;
                    }
                }
            }));
//        style.push(new ol.style.Style({
//            fill: new ol.style.Fill({color: 'rgba(255, 50, 50, 0.2)'}),
//            stroke: new ol.style.Stroke({color: 'rgba(255, 50, 50, 0.9)', width: 1.25}),
//            image: new ol.style.Circle({
//                fill: new ol.style.Fill({
//                    color: 'rgba(255, 50, 50, 0.2)'
//                }),
//                stroke: new ol.style.Stroke({
//                    width: 2,
//                    color: 'rgba(255, 50, 50, 0.9)'
//                }),
//                radius: 5
//            })
//
//        }));
            return style;
        },
        get_style_with_ops: function (ops) {
            return new ol.style.Style(ops);
        },
        get_radar_range_style: function () {
            var style_ops = {
                fill: new ol.style.Fill({
                    color: 'rgba(200, 200, 200, 0.4)'
                }),
                stroke: new ol.style.Stroke({
                    width: 1,
                    color: 'rgba(200, 200, 200, 0.4)'
                })
            };

            // Additional style informaiton needed for a point.
            style_ops.image = new ol.style.Circle({
                fill: new ol.style.Fill({
                    color: 'rgba(200, 200, 200, 0.4)'
                }),
                stroke: new ol.style.Stroke({
                    width: 1,
                    color: 'rgba(200, 200, 200, 0.4)'
                }),
                radius: 500
            });
            return new ol.style.Style(style_ops);
        },
        /*
         * Determine if this method is needed in the future...
         */



        set_layer_style_ops: function (ops) {
            this.options.layer_style_ops = ops;
        },
        get_layer_style_ops: function () {
            return this.options.layer_style_ops;
        },
        get_layer_style: function (feature, resolution) {
            var style_type = this.get_style_type();
            if (this['get_' + style_type + '_layer_style_method']) {
                var method = this['get_' + style_type + '_layer_style_method'];
                return method(feature, resolution);
            }
            return [];
        },
        get_county_layer_style_method: function (feature, resolution) {
            var style = [];
            var highlighted = feature.get('highlighted');
            var selected = feature.get('selected');
            if (selected) {
                this.get_selected_style({}, style);
            }
            if (highlighted) {
                var name = feature.get("NAME");
                if (name) {
                    this.get_text_style(name, style);
                }
                this.get_highlighted_style({}, style);
            }

            if (!selected && !highlighted) {
                style.push(new ol.style.Style({
                    fill: new ol.style.Fill({color: 'rgba(255, 255, 255, 0.2)'}),
                    stroke: new ol.style.Stroke({color: 'rgba(0, 0, 0, 0.9)', width: 1.25})

                }));
            }
            return style;
        },
        get_point_select_layer_style_method: function (feature, resolution) {
            var style = [];
            var highlighted = feature.get('highlighted');
            var selected = feature.get('selected');
            if (selected) {
                this.get_selected_style({}, style);
            }
            if (highlighted) {
                var name = feature.get("NAME");
                if (name) {
                    this.get_text_style(name, style, {offsetY: -20});
                }
                this.get_highlighted_style({}, style);
            }

            if (!selected && !highlighted) {
                style = this.get_point_layer_style_method(feature, resolution);

            }
            return style;
        },
        get_layer_style_method: function () {
            var method = this.get_layer_style.bind(this);
            var style_type = this.get_style_type();
            if (this['get_' + style_type + '_layer_style_method']) {
                method = this['get_' + style_type + '_layer_style_method'].bind(this);
            }
            return method;
        }

    });
};
OCS.Viewer.Classes.OlStyleManager = OCS.Viewer.Functions.define_ol_style_manager();